export enum ApplicationStatuses {
    IN_PREPARATION = 'in_preparation',
    FOR_FIRST_APPROVAL = 'for_first_approval',
    FIRST_APPROVED = 'first_approved',
    REJECTED = 'rejected',
    FOR_SECOND_APPROVAL = 'for_second_approval',
    SECOND_APPROVED = 'second_approved',
    INCORRECT = 'incorrect',
    IN_SETTLEMENT = 'in_settlement',
}

export enum ApplicationSettlementStatuses {
    AWAITING_SETTLEMENT = 'awaiting_settlement',
    PARTIALLY_SETTLED = 'partially_settled',
    SETTLED = 'settled',
}
